import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../utils/constants';

const PaymentFailurePage = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate(ROUTES.COURSES);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 flex items-center justify-center p-6" dir="rtl">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-3xl shadow-custom-lg p-8 md:p-12 text-center animate-slideUp">
          {/* Error Icon */}
          <div className="w-24 h-24 bg-gradient-to-br from-red-400 to-red-600 rounded-full flex items-center justify-center text-white text-5xl mx-auto mb-8">
            <i className="fas fa-times"></i>
          </div>

          {/* Error Message */}
          <h1 className="text-4xl font-black text-text mb-4">
            فشلت عملية الدفع
          </h1>
          
          <p className="text-xl text-text2 mb-8">
            للأسف، لم تكتمل عملية الدفع. يرجى المحاولة مرة أخرى
          </p>

          {/* Possible Reasons */}
          <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-6 mb-8 text-right">
            <h3 className="text-lg font-bold text-text mb-4">الأسباب المحتملة:</h3>
            <ul className="space-y-3 text-text2">
              <li className="flex items-start">
                <i className="fas fa-circle text-xs text-red-400 mt-1.5 ml-3"></i>
                <span>رصيد غير كافٍ في البطاقة</span>
              </li>
              <li className="flex items-start">
                <i className="fas fa-circle text-xs text-red-400 mt-1.5 ml-3"></i>
                <span>معلومات البطاقة غير صحيحة</span>
              </li>
              <li className="flex items-start">
                <i className="fas fa-circle text-xs text-red-400 mt-1.5 ml-3"></i>
                <span>تم إلغاء العملية من طرفك</span>
              </li>
              <li className="flex items-start">
                <i className="fas fa-circle text-xs text-red-400 mt-1.5 ml-3"></i>
                <span>مشكلة تقنية مؤقتة</span>
              </li>
            </ul>
          </div>

          {/* Countdown */}
          <p className="text-text3 mb-6">
            سيتم تحويلك لصفحة الدورات خلال {countdown} ثواني...
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate(ROUTES.COURSES)}
              className="btn-primary text-lg px-8 py-4"
            >
              <i className="fas fa-redo ml-2"></i>
              العودة للدورات
            </button>
            <button
              onClick={() => navigate(ROUTES.HOME)}
              className="btn-secondary text-lg px-8 py-4"
            >
              <i className="fas fa-home ml-2"></i>
              الصفحة الرئيسية
            </button>
          </div>

          {/* Support Info */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-text3 mb-3">
              <i className="fas fa-question-circle ml-1"></i>
              تحتاج مساعدة؟
            </p>
            <p className="text-sm text-primary font-bold">
              تواصل مع الدعم الفني عبر البريد الإلكتروني
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailurePage;
